import { render } from "./EventsCard.vue?vue&type=template&id=282bd8a0&scoped=true"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"

import "./EventsCard.vue?vue&type=style&index=0&id=282bd8a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-282bd8a0"

export default script